import {
  CancelledStatusStatusEnum,
  SuperBillControllerApi,
} from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useCancelSuperBill = () =>
  useMutationWithLoading(
    async (param: { superBillId: string; cancelReason: string }) =>
      new SuperBillControllerApi(getConfigObject()).cancelledStatus(
        param.superBillId,
        CancelledStatusStatusEnum.Cancelled,
        param.cancelReason,
        getXtenantId()
      )
  );
